import React, { PureComponent } from 'react';
import { withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// Modules
import { AutoSizer } from 'react-virtualized';

// ui/ux
import Box from '@material-ui/core/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
// ours
import ColorCanvas from './ColorCanvas';

class ColorScaleSelector extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    };

    this.onMenuClosed = this.onMenuClosed.bind(this);
    this.onMenuOpen = this.onMenuOpen.bind(this);
  }
  onMenuClosed(d) {
    this.setState({
      anchorEl: null
    });

    if (d && this.props.onRampChange) {
      this.props.onRampChange(d);
    }
  }
  onMenuOpen({ target }) {
    this.setState({
      anchorEl: target
    });
  }
  render() {
    const { className, ramp, availableRamps } = this.props;
    const { anchorEl } = this.state;
    return (
      <Box className={className}>
        <AutoSizer>
          {(dim) => (
            <React.Fragment>
              <ButtonBase style={{ ...dim, display: 'flex' }} onClick={this.onMenuOpen}>
                <ColorCanvas {...dim} ramp={ramp} />
              </ButtonBase>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => this.onMenuClosed()}>
                {availableRamps.map((d) => (
                  <MenuItem key={d.k} onClick={() => this.onMenuClosed(d)}>
                    <ColorCanvas {...dim} ramp={d.v} />
                  </MenuItem>
                ))}
              </Menu>
            </React.Fragment>
          )}
        </AutoSizer>
      </Box>
    );
  }
}

ColorScaleSelector.propTypes = {
  availableRamps: PropTypes.array.isRequired,
  className: PropTypes.string,
  onRampChange: PropTypes.func.isRequired,
  ramp: PropTypes.func.isRequired
};

ColorScaleSelector.defaultProps = {};

export default withTheme(ColorScaleSelector);
